import { getAssets, HydrationScript } from 'solid-js/web';
import { IRootProps } from 'Shared/Root';
import { convertUserIds } from 'Browser/User';
import { convertSiteId } from 'Common/SiteBasics';

export function IndexHtml(P:IRootProps)
{
	const buildLink = P.build.storeForBuiltAssets == 'production' ? '_build' : '_devBuild';

	/* Needs to be separated from the JSX, otherwise the SSR interferes for some reason. */
	const basicData = `
		window.build = ${JSON.stringify(P.build)};
		window.site = ${JSON.stringify(convertSiteId(P.site))};
		window.user = ${JSON.stringify(convertUserIds(P.user.toJson()))};
	`;

	return (
		<html lang='en'>
			<head>
				<meta charset='UTF-8' />
				<meta name='viewport' content='width=device-width, initial-scale=1.0' />
				<meta http-equiv='Content-type' content='text/html; charset=utf-8'/>
				<meta name="color-scheme" content="only light" />

				<style>{`
					* {
						box-sizing: border-box;
					}

					html {
						/* Prevent rubber band scrolling on Firefox */
						overscroll-behavior-y: none;
					}

					:root {
						color-scheme: only light;
					}

					body {
						margin: 0;
						width: 100%;
						opacity: 0;
						transition: opacity 0.2s;

						/* Prevent horizontal movement on mobiles */
						/* FullWidthStyle also needs this - without it Chrome has a small horizontal scrollbar due to use of 100vw. */
						overflow-x: hidden;
					}
				`}</style>

				{getAssets()}

				<HydrationScript />
			</head>
			<body>
				{P.children}

				<script>{basicData}</script>
				<script type='module' src={`/${buildLink}/${P.build.key}/BrowserApp.js`} />
			</body>
		</html>
	);
}

